
import { PaymentType } from '@/types/payment';

export const mockPayments: PaymentType[] = [
  {
    id: '1',
    referrerId: 'REF001',
    referrerName: 'John Smith',
    amount: 150.00,
    status: 'pending',
    date: '2025-04-01',
    method: 'bank_transfer',
    email: 'john.smith@example.com',
    accountNumber: '****4567'
  },
  {
    id: '2',
    referrerId: 'REF002',
    referrerName: 'Sarah Johnson',
    amount: 220.50,
    status: 'completed',
    date: '2025-04-02',
    method: 'paypal',
    email: 'sarah.j@example.com'
  },
  {
    id: '3',
    referrerId: 'REF003',
    referrerName: 'Michael Brown',
    amount: 105.75,
    status: 'pending',
    date: '2025-04-10',
    method: 'bank_transfer',
    email: 'mbrown@example.com',
    accountNumber: '****7890'
  },
  {
    id: '4',
    referrerId: 'REF004',
    referrerName: 'Emma Wilson',
    amount: 300.00,
    status: 'completed',
    date: '2025-03-28',
    method: 'bank_transfer',
    email: 'ewilson@example.com',
    accountNumber: '****2345'
  },
  {
    id: '5',
    referrerId: 'REF005',
    referrerName: 'James Taylor',
    amount: 175.25,
    status: 'rejected',
    date: '2025-03-25',
    method: 'paypal',
    email: 'jtaylor@example.com',
    rejectionReason: 'Invalid account information'
  },
  {
    id: '6',
    referrerId: 'REF006',
    referrerName: 'Olivia Davis',
    amount: 120.00,
    status: 'pending',
    date: '2025-04-12',
    method: 'venmo',
    email: 'odavis@example.com'
  }
];
